import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessComponent }    from './access.component';

const SECURITY_ROUTES: Routes = [
  { path: 'security/access', component: AccessComponent }
];

export const ROUTABLE_COMPONENTS = [
];

@NgModule({
  imports: [
    RouterModule.forChild(SECURITY_ROUTES)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class AccessRoutingModule {}